import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-brand-lavenderLight last:border-none" data-id="element-179">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-180">
        <span className="text-lg font-medium text-brand-dark group-hover:text-brand-lavender transition-colors" data-id="element-181">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="ml-4 flex-shrink-0 text-brand-lavender" data-id="element-182">
          <ChevronDown className="w-5 h-5" data-id="element-183" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-184">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-185">
            <div className="pb-6 text-brand-dark/80 leading-relaxed" data-id="element-186">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-6 md:p-8" data-id="element-187">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-188" />)}
    </div>;
}